import ModalElement from '@/views/elements/modal/ModalElement';

import CloseIcon from '@mui/icons-material/Close';
import { Stack, useTheme } from '@mui/material';
import { TYPE_REGISTER } from './HomeCPComponent';
import ButtonElement from '@/views/elements/button/ButtonElement';
import classNames from 'classnames/bind';
import styles from './ModalRegisterMasterFollower.module.scss';
import { ReactComponent as IconInfo } from '@/views/assets/icons/Info.svg';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import useIsMobile from '@/componentShare/hooks/useIsMobile';
import { useMemo } from 'react';

const cx = classNames.bind(styles);

export default function ModalRegisterMasterFollower({
    open,
    handleClose,
    setTypeRegister,
    setOpenModalRegister
}: {
    open: boolean;
    handleClose: () => void;
    setTypeRegister: (type: TYPE_REGISTER) => void;
    setOpenModalRegister: (isOpen: boolean) => void;
}) {

    const { t } = useTranslation()
    const theme = useTheme()
    const matches = useIsMobile()

    const registerMaster = () => {
        setTypeRegister('MASTER');
        handleClose();
        setOpenModalRegister(true);
    };

    const registerFollower = () => {
        setTypeRegister('FOLLOWER');
        handleClose();
        setOpenModalRegister(true);
    };

    const style = useMemo(() => {
        return {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: matches ? "98%" : 'auto',
            bgcolor: theme.palette.background.default,
            px: 2,
            pt: 2,
            pb: 4,
            borderRadius: 2
        }
    }, [matches])

    return (
        <div>
            <ModalElement
                disableEscapeKeyDown={true}
                hideBackdrop={true}
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                styleBox={style}
                sx={{
                    backgroundColor: theme.palette.background.backdrop
                }}
            >
                <>
                    <Stack
                        spacing={1}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                    >
                        <Stack
                            spacing={1}
                            direction={"row"}
                            alignItems={"center"}
                        >
                            {/* <InfoIcon /> */}
                            <IconInfo />
                            <TypographyElement FontWeightElement={700} FontSizeElement='18px' ColorElement='primary' id="modal-modal-title">
                                {t('copytrade.registerFollower.eCopytradeMember')}
                            </TypographyElement>
                        </Stack>
                        <CloseIcon onClick={handleClose} />
                    </Stack>
                    <TypographyElement FontWeightElement={400} FontSizeElement='16px' ColorElement='secondary' id="modal-modal-description" sx={{ my: 2 }}>
                        {t('copytrade.registerFollower.registerNow')}
                    </TypographyElement>

                    <Stack
                        direction={"row"}
                        spacing={2}
                        justifyContent={"center"}
                    >
                        <ButtonElement customType='Secondary' className={cx("btn-register")} variant="contained"
                            onClick={() => registerMaster()}>{t('copytrade.registerFollower.regMaster')}</ButtonElement>
                        <ButtonElement customType='Primary' className={cx("btn-register")} variant="contained"
                            onClick={
                                () => registerFollower()
                            }>{t('copytrade.registerFollower.regFollower')}</ButtonElement>
                    </Stack>
                </>
            </ModalElement>
        </div>
    );
}
